/**
 * LOINC codes for osteoporosis screening (DXA bone density observations)
 * Used for HEDIS OMW (Osteoporosis Management in Women) / OMD measure
 */
export const OSTEOPOROSIS_SCREENING_LOINC_CODES = [
  "24966-4", // DXA Lumbar spine [Mass/Area] Bone density
  "38263-0", // DXA Femur [T-score] Bone density
  "38264-8", // DXA Hip [T-score] Bone density
  "38267-1", // DXA Lumbar spine [T-score] Bone density
  "38268-9", // DXA Skeletal system Views for bone density
  "46278-8", // DXA Hip - left [Mass/Area] Bone density
  "80938-4", // DXA Hip - left [Z-score] Bone density
  "80940-0", // DXA Femur - left [Z-score] Bone density
  "80946-7", // DXA Hip - left [T-score] Bone density
  "80948-3", // DXA Femur - left [T-score] Bone density
  "80954-1", // DXA Femur - left [Mass/Area] Bone density
  "83311-1", // Bone density quantitative measurement by DXA panel
  "85394-5", // DXA Lumbar spine [Z-score] Bone density
];

/**
 * SNOMED CT codes for osteoporosis screening (bone density measurement)
 * Used for HEDIS OMW (Osteoporosis Management in Women) / OMD measure
 * Excludes: 363679005 (Imaging - too generic, not bone density specific)
 */
export const OSTEOPOROSIS_SCREENING_SNOMED_CODES = [
  "241686001", // Dual energy X-ray absorptiometry (procedure)
  "312681000", // Bone density scan (procedure)
  "413841000119101", // Dual energy X-ray absorptiometry of bone of hip joint region and bone of spine (procedure)
  "421751000119100", // Dual energy X-ray absorptiometry of axial and appendicular skeleton (procedure)
  "708690003", // Dual energy X-ray absorptiometry of bone of spine (procedure)
];

/**
 * CPT codes for osteoporosis screening (bone density measurement)
 * Excludes: local/custom codes (IMG9014020, 210HISBDS01)
 */
export const OSTEOPOROSIS_SCREENING_CPT_CODES = [
  "77080", // DXA, bone density study; axial skeleton (hips, pelvis, spine)
  "77081", // DXA, bone density study; appendicular skeleton (peripheral) (radius, wrist, heel)
  "78351", // Bone density study; dual photon absorptiometry, 1 or more sites
];
